import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-list-files',
  templateUrl: './list-files.component.html',
  styleUrls: ['./list-files.component.scss']
})
export class ListFilesComponent implements OnInit {

  @Input() files = [];
  @Input() type = "";
  @Output() update = new EventEmitter<any>();

  extensionsAttr = [
    { ext:['txt'], color:'#03a9f4', icon:'fa-file-alt' },
    { ext:['doc', 'docx', 'docm'], color:'#2196f3', icon:'fa-file-word' },
    { ext:['jpg', 'jpeg', 'gif', 'png', 'bmp', 'psd'], color:'#e8f5e9', icon:'fa-file-image' },
    { ext:['avi', 'mp4', 'mpeg', 'mwv'], color:'#d32f2f', icon:'fa-file-video' },
    { ext:['ppt', 'pptx', 'pptm'], color:'#ff5722', icon:'fa-file-powerpoint' },
    { ext:['pdf'], color:'#e91e63', icon:'fa-file-pdf' },
    { ext:['html', 'css', 'js', 'json'], color:'#fbc02d', icon:'fa-file-code' },
    { ext:['mp3', 'wav', 'wma'], color:'#2196f3', icon:'fa-file-audio' },
    { ext:['zip', 'rar', 'gzip'], color:'#cddc39', icon:'fa-file-archive' },
    { ext:['etc'], color:'#9e9e9e', icon:'fa-file' }
  ];

  constructor() { }

  ngOnInit(): void {

  }

  updateFiles(){
    this.update.emit(this.files);
  }

  deleteFile(file, i){
    this.files.splice(i, 1);
    this.updateFiles();
  }

  getColor(name){
    let ext = name.split(".")[name.split(".").length - 1].toLowerCase();
    return this.extensionsAttr.find(c => c['ext'].includes(ext)) ? this.extensionsAttr.find(c => c['ext'].includes(ext))['color'] : '#9e9e9e';
  }
  
  getIcon(name){
    let ext = name.split(".")[name.split(".").length - 1].toLowerCase();
    return this.extensionsAttr.find(c => c['ext'].includes(ext)) ? this.extensionsAttr.find(c => c['ext'].includes(ext))['icon'] : 'fa-file';
  }
}
